module.exports = __webpack_public_path__ + "img/Palestine.a7500801.png";